var cbtUtil = require("./cbtUtil");

window.addEventListener("load", function () {
    $("body").on("cbtCouponChange", function(e, cbtData) {
        if (Object.keys(cbtData).length !== 0) {
            cbtUtil.dataPush(cbtData);
        }
    });
});
